/**
 * How the source viewer opens an email body.
 *
 * The formatted HTML view is what a person can actually read. Search,
 * click-to-source, and designate still need the extracted plaintext, so those
 * opens land on that tab the same way a PDF anchor lands on extracted text.
 */

export type EmailBodyMode = 'formatted' | 'text'

export function initialEmailBodyMode(hasHtml: boolean, preferText: boolean): EmailBodyMode {
  if (!hasHtml || preferText) return 'text'
  return 'formatted'
}

export function emailFindHint(kind: string | undefined, emailMode: EmailBodyMode): string {
  if (kind === 'pdf') return 'Switch to Extracted text to search this PDF'
  if (kind === 'email' && emailMode === 'formatted') {
    return 'Switch to Extracted text to search this email'
  }
  return 'This view has no text to search'
}
